import React from 'react';

import {Policy} from 'auth/PolicyConstants';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import TextField from 'ui-library/inputs/TextField';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import Modal from 'ui-library/modals/Modal';
import {InputChangeEvent} from 'util/Types';

interface Props<T> {
  onRequestClose: () => void;
  onRequestSubmit: ({name, policyId}: {name: string; policyId: string}) => void;
  policies: Array<T>;
}

interface State<T> {
  name: string;
  policy: T | null;
}

type CloneablePolicy = Pick<Policy, 'id' | 'name'>;

export default class ClonePolicyModal<T extends CloneablePolicy> extends React.Component<Props<T>, State<T>> {
  state: State<T> = {
    name: '',
    policy: null,
  };

  _handleCreatePolicy = (): void => {
    this.props.onRequestSubmit({
      name: this.state.name,
      policyId: this.state.policy!.id,
    });
  };

  _handleSelectPolicy = (policy: T): void => {
    this.setState({
      policy,
    });
  };

  _handleChangeName = (e: InputChangeEvent): void => {
    this.setState({name: e.target.value});
  };

  render(): JSX.Element {
    const isSubmitEnabled = Boolean(this.state.name && this.state.policy);
    return (
      <Modal
        buttons={[{text: 'Save', submit: true, disabled: !isSubmitEnabled}]}
        onRequestClose={this.props.onRequestClose}
        onRequestSubmit={this._handleCreatePolicy}
        title="Clone access policy"
      >
        <TextField label="Name" value={this.state.name} onChange={this._handleChangeName} />
        <div className="u-spacing-top">
          <FieldLabel label="Access policy" />
          <SelectDropdown
            displayName={this.state.policy ? this.state.policy.name : 'Select one...'}
            menu={
              <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.FULL}>
                {this.props.policies.map((policy) => (
                  <Option key={policy.id} onSelect={this._handleSelectPolicy} value={policy}>
                    {policy.name}
                  </Option>
                ))}
              </Menu>
            }
          />
        </div>
      </Modal>
    );
  }
}
